import PropTypes from 'prop-types';

import { Content, Title, WarningText } from './confirm.styled';
import { Dialog } from '../dialog/dialog';

export const Confirm = (props) => {
  const { width = '440px', type, title, info, cancelButton, acceptButton, working, center, ...rest } = props;

  /**
   * cancel confirm
   */
  const close = () => {
    if (cancelButton) {
      cancelButton.func();
    }
  };

  /**
   * disable click
   * @param {*} event
   */
  const disableClick = (event) => {
    event.stopPropagation();
  };

  const cancelFunc = (event) => {
    disableClick(event);
    cancelButton.func();
  };

  const okFunc = (event) => {
    disableClick(event);
    acceptButton.func();
  };

  const buttons = [];
  if (cancelButton) {
    buttons.push({ title: cancelButton.text, onClick: cancelFunc });
  }
  if (acceptButton) {
    buttons.push({
      title: acceptButton.text,
      onClick: okFunc,
      theme: acceptButton.theme,
      backgroundColor: acceptButton.backgroundColor,
      disabled: working,
      working,
      img: acceptButton.img,
    });
  }
  const cl = type;
  const withInfo = !!info;
  let clTitle = withInfo ? 'with-info' : '';
  if (center) {
    clTitle += ' center';
  }
  return (
    <Dialog {...rest} closeOnOverlayClick close={close} id="confirm" buttons={buttons} w={width}>
      {/* {type && type === 'error' ? <img width={50} height={50} src="/images/error-icon.png" alt="" /> : <img width={50} height={47} src="/images/warning.png" alt="" />} */}
      <Content className={cl}>
        <Title className={clTitle}>{title}</Title>
        {typeof info === 'object' && info.__html ? <WarningText dangerouslySetInnerHTML={info} /> : info && <WarningText>{info}</WarningText>}
      </Content>
    </Dialog>
  );
};

Confirm.propTypes = {
  working: PropTypes.bool,
  width: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.any.isRequired,
  info: PropTypes.any,
  cancelButton: PropTypes.object,
  acceptButton: PropTypes.object,
};
